export default (number) => Math.ceil(number * 100) / 100
